var _style, _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 121 121",
    style: {
      enableBackground: "new 0 0 121 121"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n\t.st2{fill:none;stroke:#56C9F4;stroke-width:3;}\n\t.st3{fill:none;stroke:#56C9F4;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 121,
    height: 121
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,20h80v80H21V20z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 39)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 20.4,
    cy: 5.5,
    rx: 13.1,
    ry: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.7,46c0-12.1-11.8-21.9-26.3-21.9S-5.8,33.9-5.8,46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatar);
export default __webpack_public_path__ + "static/media/ic_avatar.78d4eef22fae7915542562ef8fbf8e8e.svg";
export { ForwardRef as ReactComponent };